import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleDefect } from '@/types/vehicle-defect'

export function getVehicleDefectDisruptive(): Promise<
  AxiosResponse<VehicleDefect[]>
> {
  return instance.get(`/vehicle-defect-disruptive/`)
}
